import React from 'react';
import classNames from 'classnames/bind';
import { TextField, Title } from '@components';
import { UseFormResult } from 'hooks';
import styles from './PaymentForm.module.scss';
import { PaymentFormFieldNames } from './form';

const CN = 'payment-form';
const fieldClassName = `${CN}--field`;
const titleClassName = `${CN}--title`;
const fieldsRowClassName = `${CN}--fields-row`;

const cx = classNames.bind(styles);

interface Props {
  formData: UseFormResult<PaymentFormFieldNames>;
}

export const PaymentForm: React.FC<Props> = ({
  formData: {
    state,
    errors,
    handleChange,
    handleBlur
  } }) => (
  <form className={ cx(CN) }>
    <Title className={ cx(titleClassName) }>
        Payment details
    </Title>
    <TextField
      required
      name='cardNumber'
      type='text'
      label='Credit Card Number'
      value={ state.cardNumber }
      className={ cx(fieldClassName) }
      onBlur={ handleBlur }
      onChange={ handleChange }
      error={ errors.cardNumber.isTouched && !errors.cardNumber.isValid }
      helperText={ errors.cardNumber.isTouched && !errors.cardNumber.isValid? errors.cardNumber.message : '' }
    />
    <div className={ cx(fieldsRowClassName) }>
      <TextField
        required
        name='expiryDate'
        type='text'
        label='Expiring MM/YY'
        value={ state.expiryDate }
        className={ cx(fieldClassName) }
        onBlur={ handleBlur }
        onChange={ handleChange }
        error={ errors.expiryDate.isTouched && !errors.expiryDate.isValid }
        helperText={ errors.expiryDate.isTouched && !errors.expiryDate.isValid? errors.expiryDate.message : '' }
      />
      <TextField
        required
        name='cvc'
        type='email'
        label='CVC Code'
        value={ state.cvc }
        className={ cx(fieldClassName) }
        onBlur={ handleBlur }
        onChange={ handleChange }
        error={ errors.cvc.isTouched && !errors.cvc.isValid }
        helperText={ errors.cvc.isTouched && !errors.cvc.isValid? errors.cvc.message : '' }
      />
    </div>
  </form>
);
